/* @flow */

import { assertObject } from '@e180/util/lib/assert';
import * as Sentry from '@sentry/browser';

import {
  getVersion,
  getEnvironment,
} from 'src/shared/app/base/selector/appEnvSelectors';
import { getSentryOptions } from 'src/shared/app/base/util/errorReportingUtils';

import type { Store } from 'src/shared/core/type/reduxTypes';

/**
 * Initialize the error reporting service
 * @param   {Store} store - Redux store
 * @returns {undefined}
 *
 * @throws Will throw an exception if parameters are not valid
 */
export function initErrorReporting(store: Store): void {
  assertObject(store, 'store');

  Sentry.init(
    getSentryOptions(
      getVersion(store.getState()),
      getEnvironment(store.getState()),
    ),
  );
}

/**
 * Add the app state to each event sent to the error reporting service
 * @param   {Store} store - Redux store
 * @returns {undefined}
 *
 * @throws Will throw an exception if parameters are not valid
 */
export function enhanceErrorReportingWithState(store: Store): void {
  assertObject(store, 'store');

  Sentry.configureScope((scope) => {
    scope.addEventProcessor((event) => {
      event.extra = { state: store.getState() };

      return event;
    });
  });
}

/**
 * Report an exception to the error reporting service
 * @param   {Error} e - Exception to report
 * @returns {undefined}
 */
export function captureException(e: Error): void {
  Sentry.captureException(e);
}
